export interface IConversation {
  conversationId?: string;
  userKey?: string;
  language?: any;
  briefingId?: string;
  sentences?: Array<Sentence>;
  resourceIds?: Array<Resource>;
  page?: string;
  docId?: string;
  createdDate?: Date;
}

export class ConversationModel implements IConversation {
  constructor(
    public conversationId?: string,
    public userKey?: string,
    public language?: any,
    public briefingId?: string,
    public sentences?: Array<Sentence>,
    public resourceIds?: Array<Resource>,
    public page?: string,
    public docId?: string,
    public createdDate?: Date
  ) {
    if (!sentences?.length) {
      this.sentences = [];
    }
    if (!resourceIds?.length) {
      this.resourceIds = [];
    }
  }
}

export class Sentence {
  role: string;
  content: string;
  datetime: any;
  resourceIds: Array<Resource>;
  messageId: string;
  isDeepAnswer: boolean;
  like?: number;
  popoverDocument?: Array<PopoverReference>;
  ipUpdateConversation: boolean;
  llmContent: Array<LLMModel>;
  llmModel?: string;

  constructor(
    role: string,
    content: string,
    datetime?: any,
    resourceIds?: any,
    messageId?: string,
    isDeepAnswer?: boolean,
    llmModel?: string,
    like?: number,
    popoverDocument?: Array<any>,
    ipUpdateConversation?: boolean
  ) {
    this.role = role;
    this.content = content;
    if (this.datetime) {
      this.datetime = datetime;
    } else {
      this.datetime = new Date();
    }
    this.messageId = messageId || '';
    this.resourceIds = resourceIds;
    this.isDeepAnswer = isDeepAnswer;
    this.like = like;
    if (this.popoverDocument) {
      this.popoverDocument = popoverDocument;
    }
    this.ipUpdateConversation = ipUpdateConversation;
    this.llmModel = llmModel;
    if (!this.llmContent) this.llmContent = [];
    this.llmContent.push({ model: this.llmModel, content: this.content });
  }
}

export class Resource {
  doc_id: string;
  title: string;
  url: string;
  published_at: string;
  content: string;
  chunk_index: number;
  chunkId: string;
  owner_user_key?: string;
  originParentDocDetail?: any;
  path?: string;
  writer?: any;

  constructor(doc_id: string, title: string, url: string, published_at: string, content: string, chunk_index: number, chunk_id?: string) {
    this.doc_id = doc_id;
    this.title = title;
    this.url = url;
    this.published_at = published_at;
    this.content = content;
    this.chunk_index = chunk_index;
    this.chunkId = chunk_id || '';
  }
}

export interface PopoverReference {
  docId?: string;
  idElement?: string;
  description?: string;
  published_at?: string;
  title?: string;
  channel?: string;
  url?: string;
  originIndex?: string;
  numRef?: number;
}

// export interface AnswerGenerationProcess {
//   message?: string;
//   isLoading?: boolean;
// }

export interface LLMModel {
  model: string;
  content: string;
}

export interface AskActivity {
  isLoading: boolean;
  activityId: string;
  content: string;
  id: string;
  description: string;
  event?: string;
}
